import * as yup from 'yup';

import { emailValidationRule, passwordValidationRule } from './validationRules';

export const signInFormSchema = yup.object({
    email: emailValidationRule,
    password: passwordValidationRule,
});
